import React, { useEffect, useState } from "react";
import { getLogs } from "./Api.js";

const LogTable = () => {
    const [logs, setLogs] = useState({});
    const [selectedClient, setSelectedClient] = useState("");
    const [upgrade, setUpgrade] = useState(false);

    var histo = {};

    useEffect(() => {
        getLogs().then((lgs) => {
            setLogs(lgs);
            const firstClient = Object.keys(lgs)[0];
            setSelectedClient(firstClient);
        });
    }, []);

    useEffect(() => {
        getLogs().then((lgs) => {
            setLogs(lgs);
            const firstClient = Object.keys(lgs)[0];
            setSelectedClient(firstClient);
        });
    }, [upgrade]);

    function findOperations(obj, operationsSet = new Set()) {
        if (obj == null)
            return [];
        if (typeof obj === "object" && obj !== null) {
            for (const key in obj) {
                if (key === "operation") {
                    operationsSet.add(obj[key]);
                }
                findOperations(obj[key], operationsSet);
            }
        } else if (Array.isArray(obj)) {
            obj.forEach(item => findOperations(item, operationsSet));
        }
        return Array.from(operationsSet); 
    }

    var sortedData = [];
    if (logs) {
        for (let acc in logs) {    
            for (let log of logs[acc]) {
                const princode = findOperations(log?.data?.["Código principal"]);
                for (let o of princode) {
                    if (histo[o] == null)
                        histo[o] = 0;
                    histo[o]++;
                }
            }
        }
        sortedData = Object.entries(histo)
        .sort((a, b) => b[1] - a[1])
        .map(([operation, frequency]) => ({ operation, frequency }));
    }

    return (
        <div style={{ width: "80vw", margin: "auto", marginTop: "20px" }}>
            <h2>Histórico de Eventos <i style={{cursor: "pointer"}} className="fa fa-refresh" onClick={()=>setUpgrade(!upgrade)}/></h2>
            <div style={{ display: "flex", marginBottom: "10px", borderBottom: "2px solid #ddd" }}>
                {Object.keys(logs).map((client) => (
                    <button
                        key={client}
                        onClick={() => setSelectedClient(client)}
                        style={{
                            padding: "10px",
                            cursor: "pointer",
                            backgroundColor: selectedClient === client ? "#ccc" : "#fff",
                            border: "none",
                            borderBottom: selectedClient === client ? "2px solid blue" : "none",
                            marginRight: "10px",
                        }}
                    >
                        {client}
                    </button>
                ))}
            </div>

            {selectedClient && logs[selectedClient] ? (
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                        <tr style={{ backgroundColor: "#f2f2f2" }}>
                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>#</th>
                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Client ID</th>
                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Usuário</th>
                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Banco de dados</th>
                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Horário</th>
                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Escopo</th>
                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Operações</th>
                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Contexto</th>
                        </tr>
                    </thead>
                    <tbody>
                        {logs[selectedClient]?.slice()?.reverse()?.map((log, index) => {
                            const princode = findOperations(log.data["Código principal"]);
                            return <tr key={index} style={{ textAlign: "center" }}>
                                <td style={{ padding: "10px", border: "1px solid #ddd" }}><b>{index}</b></td>
                                <td style={{ padding: "10px", border: "1px solid #ddd" }}>{log.clientId}</td>
                                <td style={{ padding: "10px", border: "1px solid #ddd" }}>{log.username}</td>
                                <td style={{ padding: "10px", border: "1px solid #ddd" }}>{log.database}</td>
                                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                    {new Date(log.datetime).toLocaleString()}
                                </td>
                                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                    {log.operation === "#user"
                                        ? "Interação com usuário"
                                        : log.operation === "#tool"
                                        ? "Ação / Procedimento"
                                        : "Agente"}
                                </td>
                                <td 
                                    style={{ padding: "10px", border: "1px solid #ddd" }}
                                    dangerouslySetInnerHTML={{ __html: log.operation === "#user"
                                        ? "asking"
                                        : log.operation === "#tool"
                                        ? "calculation"
                                        : princode?.join("<br/>") 
                                    }}
                                ></td>
                                <td
                                    style={{ padding: "10px", border: "1px solid #ddd" }}
                                    dangerouslySetInnerHTML={{ __html: log.context }}
                                ></td>
                            </tr>
                        })}
                    </tbody>
                </table>
            ) : (
                <p>Nenhum dado disponível para este cliente.</p>
            )}
            {sortedData?.length > 0 && <>
                <br/><br/>
                <h2>Tabela de Frequência de Operações</h2>
                <div style={{ display: "flex", paddingTop: "18px", paddingBottom: "25px", borderTop: "2px solid #ddd" }}>
                  <table border="1" cellPadding="8" cellSpacing="0">
                    <thead>
                      <tr>
                        <th>Operação</th>
                        <th>Frequência</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sortedData.map(({ operation, frequency }, index) => (
                        <tr key={index}>
                          <td>{operation}</td>
                          <td>{frequency}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
            </>}
        </div>
    );
};

export default LogTable;
